import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'enumLabel',
})
export class EnumLabelPipe implements PipeTransform {
  transform<T>(value: T, labelsMap: Record<string, string>): string {
    return labelsMap[value as string] ?? value;
  }
}
